/** Shared message for visitors and participants when the programme has no places left. */
export function BetaFull() {
  return <div data-testid="beta-full">
    <p className="cap">Player Spotlight Program</p>
    <h1 className="mt16">The Player Spotlight Program is full</h1>
    <p className="sub mt16">Thank you for your interest! All places in this round have been filled.</p>
  </div>;
}
